import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.sustainability.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.sustainability.fields.name'),
  },
  {
    name: 'message',
    label: i18n('entities.sustainability.fields.message'),
  },
  {
    name: 'logos',
    label: i18n('entities.sustainability.fields.logos'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.sustainability.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.sustainability.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
